<template>
  <div id="app">
    <router-view v-wechat-title='$route.meta.title' v-if="isRouterAlive"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload
    }
  },
  data() {
    return{
      isRouterAlive: true                    //控制视图是否显示的变量
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false;            //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true;         //再打开
      })
    }
  }
}
</script>

<style>
/*@media screen and (min-width:1200px){*/
/*  #app {*/
/*    width: 20%;*/
/*  }*/
/*}*/
/*@media screen and (min-width:992px){*/
/*  #app {*/
/*    width: 30%;*/
/*  }*/
/*}*/
/*@media screen and (min-width:768px){*/
/*  #app {*/
/*    width: 40%;*/
/*  }*/
/*}*/
/*@media screen and (min-width:480px){*/
/*  #app {*/
/*    width: 50%;*/
/*  }*/
/*}*/

#app {
  position: fixed;
  top: 0;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color:#fff;
  width:100vw;
  height:100vh;
  overflow:hidden;
}
.main-box{
}
.page-web-box{
  width:100vw;
  height:100vh;
  overflow:hidden;
}
.page-web-box-auto{
  width:100vw;
  height:100vh;
  overflow:auto;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue